import { render, staticRenderFns } from "./CssGridTest.demo.vue?vue&type=template&id=2081f481&scoped=true&"
var script = {}
import style0 from "./CssGridTest.demo.vue?vue&type=style&index=0&id=2081f481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2081f481",
  null
  
)

export default component.exports